import { ModuleEnum } from '../../../_utils/unums/module.enum';

export const BREADCRUMB_SETTINGS = {
  module: {
    [ModuleEnum.feedback]: 'Feedback for success',
    [ModuleEnum.conversations]: 'Difficult conversations',
    [ModuleEnum.interviews]: 'Interviews',
    [ModuleEnum.salesAndServices]: 'Sales & services',
    [ModuleEnum.motivation]: 'Motivate from purpose',
    [ModuleEnum.health_dialogues]: 'Valuable conversation with patients',
    [ModuleEnum.telefonica]: 'Telefónica',
  }
};
